<template>
  <div
    id="playBack"
    style="z-index: 99;"
  >
    <b-card
      v-if="playBackVisible"
      title=""
      class="playBackMob"
      style="margin-left: -10px;"
    >
      <div style="display: block;padding: 10px 5px 0 5px;direction: ltr;width:100vw;">

        <div
          v-if="!PlayStatus"
          class="playBtn"
          style="left: 5px;"
          @click="onClickStartPlay()"
        >
          <v-icon
            color="rgb(28, 125, 230)"
            size="28"
          >mdi-play-circle</v-icon>
        </div>
        <div
          v-else
          class="playBtn"
          @click="onClickPausePlay()"
        >
          <v-icon
            color="rgb(230, 28, 28)"
            size="28"
          >mdi-pause-circle</v-icon>
        </div>
        <div style="width: 80%;margin: auto;  margin-top: auto;margin-top: 10px;">
          <b-progress
            ref="listenTo"
            :value="playBackValue"
            max="100"
            height="2px"
            style="cursor: pointer;padding-top: 3px;padding-bottom: 3px;"
            @click.native="getClickPosition($event)"
          />
        </div>
        <div
          class="playBtn"
          style="right: 5px;"
          @click="onClickStopPlay()"
        >
          <v-icon
            color="rgb(230, 28, 28)"
            size="28"
          >mdi-stop-circle</v-icon>
        </div>
        <!-- کنترل سرعت پخش به عنوان دکمه‌های انتخابی -->
        <div style="display: flex; justify-content: center; padding-top: 10px;">
          <b-button-group>
            <b-button
                v-for="play_speed in [1, 2, 4, 8]"
                :key="play_speed"
                :variant="playbackSpeed === play_speed ? 'primary' : 'outline-primary'"
                @click="playbackSpeed = play_speed"
            >
              {{ play_speed }}x
            </b-button>
          </b-button-group>
        </div>
      </div>
      <v-row style="margin: 0px 0px 2px 0px;font-size: 0.9rem;">
        <v-col
          cols="12"
          style="padding: 0rem 0.4rem 0.4rem 0.4rem !important;text-align: center;direction: ltr;font-size: 0.8rem;"
        >
          {{ this.mapHistoryDateFromFormatted }} {{ this.mapHistoryTimeStart }} -
          {{ this.mapHistoryDateFromFormatted }} {{ this.mapHistoryTimeEnd }}
        </v-col>

      </v-row>

      <hr style="margin:0">
      <v-row style="margin: 2px 0px;font-size: 0.9rem;">
        <v-col
          cols="4"
          style="direction: ltr;text-align: right;"
        > {{ averageSpeed }} Km/h
        </v-col>
        <v-col
          cols="4"
          style="direction: ltr;text-align: center;"
        >{{ speedHistory }} Km/h
        </v-col>
        <v-col
          cols="4"
          style="padding: 0.4rem !important;text-align: left;"
        >
          <span style="width: 100%;display: block;">{{ timeHistory(dateHistory) }}</span>
          <span style="width: 100%;display: block;color: #aaa;">{{ datesHistory(dateHistory) }}</span>
        </v-col>
      </v-row>
      <hr style="margin:0">
      <v-row style="margin: 2px 0px;font-size: 0.9rem;">
        <v-col
          cols="8"
          style="padding: 0.4rem !important;"
        />
        <v-col
          cols="4"
          style="padding: 0.4rem !important;text-align: left;"
        >
          {{ getPopupInfo(selectedImei).title }}
        </v-col>

      </v-row>
    </b-card>
    // باکس انتخاب تاریخ
    <b-card
      v-show="historySideBarVisible && !playBackVisible"
      class="historySideBar"
    >
      <div class="historySideBarBody">
        <div class="justify-content-center">
          <div
            class="col-10 col-md-12 "
            style="display: flex;padding-top: 0px;padding-bottom: 0px;margin: auto;"
          >
            <div
              class="historySideBar-btn"
              @click="NextDay"
            >
              <v-icon size="20">
                mdi-chevron-right
              </v-icon>
            </div>
            <date-picker
              v-model="mapHistoryDateFromFormatted"
              :disable="checkDate"
              :locale="$t('lang')"
              style="margin: 0 5px;"
              append-to="body"
            />
            <div
              class="historySideBar-btn"
              @click="PreviousDay"
            >
              <v-icon size="20">
                mdi-chevron-left
              </v-icon>
            </div>
          </div>
        </div>
        <div
          class="row"
          style="margin-top: 0;padding-left: 0;"    :dir="$functions.currentLangDirection()"
        >
          <div
            class="col-4 col-md-6"
            style="display: flex;"
          >
            <label style="padding: 8px;">{{ $t('From') }}: </label>
            <date-picker
              v-model="mapHistoryTimeStart"
              type="time"
              append-to="body"
            />
          </div>
          <div
            class="col-4 col-md-6"
            style="display: flex;padding-right: 0;"
          >
            <label style="padding: 8px;">{{ $t('To') }}</label>
            <date-picker
              v-model="mapHistoryTimeEnd"
              type="time"
              append-to="body"
            />
          </div>
          <div
            class="col-4 col-md-12"
            style="display: flex;"
          >
            <b-button
              class="btn btn-info btn-sm"
              style="width: 100%;border-color: #0594d9 !important;background-color: #00abfd !important;"
              @click="mapWayPointsAction()"
            >
              {{ $t('View') }}
            </b-button>
          </div>
        </div>
      </div>
    </b-card>

    <div
      v-show="isMobile && !historySideBarVisible"
      class="mobileOnMapHint mobileOnMapHintBtns mobileOnMapHistoryBtn"
    />
    <div
      v-show="isMobile && !historySideBarVisible"
      class="mobileOnMapHint mobileOnMapHintBtns mobileOnMapHintCrosshairBtn"
    >
      <b-button
        variant="gradient-light"
        class="btn-sm "
        style="background: rgb(255, 255, 255) !important;"
        @click="onMobileMapSetMyLocation"
      >

        <v-icon
          size="26"
          color="#6f6f6f"
        >mdi-crosshairs-gps</v-icon>
      </b-button>
    </div>

    <div dir="ltr">
      <l-map
        id="playBackMap"
        ref="map"
        dir="ltr"
        :zoom="zoom"
        :center="center"
        :min-zoom="5"
        :max-bounds="[[24.5, 44.0], [40.0, 63.5]]"
        :max-bounds-viscosity="1.0"
        :options="{zoomControl: true,preferCanvas: true}"
      >
        <l-control-layers position="bottomleft" />
        <l-tile-layer
          v-for="tileProvider in tileProviders"
          :key="tileProvider.name"
          :name="tileProvider.name"
          :visible="tileProvider.visible"
          :url="tileProvider.url"
          :attribution="tileProvider.attribution"
          :subdomains="tileProvider.subdomains"
          layer-type="base"
        />
        <v-rotated-marker
          v-for="(marker, imei) in mapMarkers"
          :key="imei"
          ref="marker"
          :visible="marker.visible"
          :lat-lng="marker.latlng"
          :rotation-angle="marker.rotationAngle"
          :icon="marker.state === 'myLocation' ? myLocationIcon: marker.state === 'start' ? StartMoveIcon : marker.state === 'end' ? EndMoveIcon : marker.state === 'stop' ? StopMoveIcon : mapCarIcon[imei]"
        />
        <l-polyline
          :lat-lngs="polyline.latlngs"
          :color="polyline.color"
          :weight="2"
        />
      </l-map>
    </div>
  </div>
</template>
<script>
import jalalimoment from 'jalali-moment'

import {
  BCard, BCardBody, BCardText, BLink, BButton, BFormInput, BButtonGroup, BFormGroup, BFormSelect, BFormSelectOption,
  BProgress, BProgressBar, BForm,
} from 'bootstrap-vue'
import {
  LMap, LTileLayer, LMarker, LControlZoom, LPolyline, LPopup, LControlLayers,
} from 'vue2-leaflet'
import Vue2LeafletRotatedMarker from 'vue2-leaflet-rotatedmarker'
import 'leaflet-routing-machine'
import 'leaflet/dist/leaflet.css'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import Vue from 'vue'
import deviceService, { DeviceService } from '@/services/device.service'
import router from '@/router'
import Device from '@/models/device'
import Config from '../../../config'
import { getUserData } from '@/auth/utils'
import UserService from '@/services/user.service'
import BreadcrumbMobile from '@/layouts/breadcrumb.vue'

const LeafIcon = L.Icon.extend({
  options: {
    shadowSize: [30, 40],
    iconAnchor: [30, 18],
    shadowAnchor: [2, 42],
    popupAnchor: [-3, -20],
    iconSize: [60, 36],
  },
})
const myLeafIcon = L.Icon.extend({
  options: {
    shadowSize: [30, 40],
    iconAnchor: [18, 18],
    shadowAnchor: [18, 18],
    popupAnchor: [-3, -40],
    iconSize: [36, 36],
  },
})
const PinLeafIcon = L.Icon.extend({
  options: {
    shadowSize: [30, 40],
    iconAnchor: [15, 50],
    shadowAnchor: [18, 18],
    popupAnchor: [-3, -40],
    iconSize: [30, 54],
  },
})

export default {
  components: {
    BProgress,
    BCard,
    BCardBody,
    BLink,
    BButton,
    LMap,
    LTileLayer,
    LPolyline,
    LMarker,
    LPopup,
    LControlZoom,
    LControlLayers,
    datePicker: VuePersianDatetimePicker,
    BForm,
    BreadcrumbMobile,
    'v-rotated-marker': Vue2LeafletRotatedMarker,
  },
  data() {
    return {
      playbackSpeed: 1, // مقدار اولیه سرعت پخش
      deviceInfobottom: '-129px',
      deviceInfoBox: true,
      deviceTracking: false,
      search: '',
      desserts: [],
      lastAngle: 0,
      dateHistory: '',
      speedHistory: 0,
      playBackVisible: false,
      PlayStatus: false,
      playTimerPointer: 0,
      playBackValue: 0,
      options: Config.carTypes,
      device: new Device('', '', '', '', '', '', '', '', '', ''),
      timer: null,
      speed: 0,
      averageSpeed: 0,
      address: null,
      tileProviders: [
        {
          name: 'Map.ir',
          visible: true,
          attribution: '© Map.ir',
          url: `${Config.mapir.tileUrl}?x-api-key=${Config.mapir.apiKey}`,
        },
        {
          name: 'OpenStreetMap',
          visible: false,
          attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
          url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        },
      ],
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      zoom: 5,
      // Iran position
      center: [32.4207, 53.6830],
      mapMarkers: {},
      listLimitDevice: {},
      historySideBarVisible: true,
      mapHistoryDateFromFormatted: '',
      mapHistoryTimeStart: '00:00',
      mapHistoryTimeEnd: '23:59',
      mapHistoryTimesSelected: {},
      isMobile: Vue.prototype.$functions.isMobile(),
      selectedDevice: this.$mobileSelectedDevices[0],
      selectedDeviceTracking: null,
      selectedImei: Vue.prototype.$selectDevicePlayBack,
      polyline: {
        latlngs: [],
        color: 'red',
      },
      mapCarIcon: new LeafIcon({
        iconUrl: require('@/assets/images/pins/cars/car.png'),
      }),
      myLocationIcon: new myLeafIcon({
        iconUrl: require('@/assets/images/pins/myloc.png'),
      }),
      StartMoveIcon: new PinLeafIcon({
        iconUrl: require('@/assets/images/pins/startmarker-min.png'),
      }),
      EndMoveIcon: new PinLeafIcon({
        iconUrl: require('@/assets/images/pins/endmarker-min.png'),
      }),
      StopMoveIcon: new PinLeafIcon({
        iconUrl: require('@/assets/images/pins/stopmarker-min.png'),
      }),
      newtitle: '',
      smsconfigtext: 'SERVER,0,s1.4-rah.com,4000,0#',
      items: [
        { title: 'تغییر نام خودرو', icon: 'mdi-account-edit', action: 'modal-change-name' },
        { title: 'تغییر نوع خودرو', icon: 'mdi-car', action: 'modal-change-category' },
        { title: 'تغییر سیمکارت', icon: 'mdi-sim-alert', action: 'modal-change-sim' },
        { title: 'ارسال تنظیمات سرور', icon: 'mdi-apple-keyboard-shift', action: 'modal-send-sms' },
      ],
    }
  },
  created() {
    this.QXUpdateFirebaseData()
    this.$vuetify.rtl = true
    // this.showMarkers()
    this.checkOnlineStatus()
    this.doAction()
  },
  mounted() {
    this.todayWayPoints()
  },
  methods: {
    checkDate(formatted, dateMoment, checkingFor) {
      return (
        dateMoment.jDate() > jalalimoment().locale('fa').format('D')
          || dateMoment.jMonth() >= jalalimoment().locale('fa').format('M')
          || dateMoment.jYear() > jalalimoment().locale('fa').format('YYYY')
      )
    },
    QXUpdateFirebaseData() {
      UserService.updateFirebaseDataIfNeeded({})
    },
    getClickPosition(event) {
      const e = event || window.e
      // get target element
      let target = e.target || e.srcElement
      // fix for a safari bug
      if (target.nodeType === 3) target = target.parentNode
      // set initial wrapper width
      this.wrapperWidth = this.wrapperWidth || target.offsetWidth
      // get the seek width
      const seekWidth = e.offsetX
      // change seek position
      this.playBackValue = (seekWidth / this.wrapperWidth) * 100
      this.onClickPausePlay()
      // eslint-disable-next-line radix
      this.StartPlay(parseInt((this.playBackValue * this.polyline.latlngs.length) / 100))
    },
    showMarkers() {
      const index = Vue.prototype.$functions.getDeviceIndex(this.selectedImei)
      if (index === -1) return
      const device = Vue.prototype.$devices[index]
      if (!device || !device.serverInfo) return
      const coords = Vue.prototype.$functions.getLatLngFromServerInfo(device.serverInfo)
      if (!coords) return
      const data = {
        latitude: coords.lat,
        longitude: coords.lng,
        imei: device.imei,
      }
      const deviceInfo = Vue.prototype.$functions.getDeviceInfo(data.imei)
      if (typeof this.options[deviceInfo.category] === 'undefined') {
        deviceInfo.category = 0
      }
      this.mapCarIcon[device.imei] = new LeafIcon({
        // eslint-disable-next-line global-require,import/no-dynamic-require
        iconUrl: require(`@/assets/images/pins/cars/${this.options[deviceInfo.category].src}.png`),
      })
      this.addUpdateMarker(data)
      this.$forceUpdate()
    },
    getFixDeviceInfo(device) {
      return Vue.prototype.$functions.fixDeviceInfo(device)
    },
    calcAngle(cx, cy, ex, ey) {
      const dy = ey - cy
      const dx = ex - cx
      // range (-PI, PI]
      let theta = Math.atan2(dy, dx)
      // rads to degs, range (-180, 180]
      theta *= 180 / Math.PI
      // if (theta < 0) theta = 360 + theta; // range [0, 360)
      return theta
    },
    getMyLocation() {
      // additionally, supplying options for fine-tuning, if you want to
      const options = {
        enableHighAccuracy: true,
        // time in millis when error callback will be invoked
        timeout: 5000,
        // max cached age of gps data, also in millis
        maximumAge: 0,
      }
      return new Promise(((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
          pos => { resolve(pos) },
          err => { reject(err) },
          options,
        )
      }))
    },
    async onMobileMapSetMyLocation() {
      const position = await this.getMyLocation()
      if ('coords' in position) {
        const data = {
          imei: '123456', state: 'myLocation', latitude: position.coords.latitude, longitude: position.coords.longitude,
        }
        this.addUpdateMarker(data)
        this.setMapCenterAndZoom([data.latitude, data.longitude], 16)
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'پیام',
            text: 'دسترسی به موقعیت مکانی شما ممکن نیست.',
            icon: 'XIcon',
            variant: 'warning',
          },
        })
      }
    },
    datesHistory(unixTime) {
      // بررسی مقادیر نامعتبر
      if (!unixTime || unixTime < 1000) return ''
      return this.$functions.unixToPersianDateS(unixTime)
    },
    timeHistory(unixTime) {
      // بررسی مقادیر نامعتبر
      if (!unixTime || unixTime < 1000) return ''
      return this.$functions.unixToPersianTime(unixTime)
    },
    sinceFrom(unixTime) {
      if (!unixTime || unixTime < 1000) {
        return this.$t('Unknown')
      }
      const time = Vue.prototype.$functions.time()
      return this.$functions.timeSince(unixTime > time ? time : unixTime)
    },
    checkOnlineStatus() {
      clearInterval(Vue.prototype.$timer)
      Vue.prototype.$timer = setInterval(() => {
        this.$socket.emit('devicesOnlineTime', {})
      }, 20000)
    },
    doAction() {
      switch (this.$route.params.action) {
        case 'history':
          this.onMobileMapShowHistoryBar()
      }
    },
    onClickPausePlay() {
      this.PlayStatus = false
    },
    onClickStopPlay() {
      this.PlayStatus = false

      this.polyline.latlngs = []
      this.playBackVisible = false

      // TODO: نیاز به بررسی بیشتر دارد و صحیح نیست
      // اما برای رفع عیب موقت هنگام بسته شدن نوار
      // تاریخچه مناسب است
      this.mapMarkers = {}
    },
    onClickStartPlay() {
      this.showMarkers()
      this.PlayStatus = true
      let index = 0
      if (this.playBackValue !== 0) {
        index = parseInt((this.playBackValue * this.polyline.latlngs.length) / 100) + 2
      }
      this.StartPlay(index)
    },
    StartPlay(index) {
      if (typeof this.polyline.latlngs[index] === 'undefined') return
      this.dateHistory = this.polyline.devicetime[index]
      this.speedHistory = this.polyline.devicespeed[index]
      this.playBackValue = parseInt((100 * index) / this.polyline.latlngs.length)
      const data1 = {
        latitude: this.polyline.latlngs[index][0],
        longitude: this.polyline.latlngs[index][1],
        imei: this.selectedImei,
      }

      this.addUpdateMarker(data1)
      setTimeout(
        () => {
          if (this.PlayStatus) {
            this.StartPlay(index + 1)
          }
        },
        1000 / this.playbackSpeed,
      )
    },
    routing(payload) {
      this.mapMarkers = {}
      this.polyline.latlngs = []
      this.polyline.devicetime = []
      this.polyline.devicespeed = []
      deviceService.getPositions({
        imeis: payload.imeis, fromDate: payload.fromDate, toDate: payload.toDate, limit: payload.limit, sortItems: payload.sortItems,
      }).then(
        resp => {
          if (resp.status === 'success') {
            if ('result' in resp) {
              const arr = []
              const arrt = []
              for (let i = 0; i <= payload.imeis.length - 1; i += 1) {
                const imei = payload.imeis[i]
                let sum = 0
                if(resp.result[imei].length < 1){
                  this.onClickStopPlay()
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: this.$t('Error'),
                      text: 'برای این تاریخ سابقه حرکتی وجود ندارد.',
                      icon: 'XIcon',
                      variant: 'danger',
                      dir: Vue.prototype.$functions.currentLangDirection(),
                    },
                  })
                  return
                }
                for (let j = 0; j <= resp.result[imei].length - 1; j += 1) {
                  if (j !== resp.result[imei].length - 1 && resp.result[imei][j].speed === 0 && resp.result[imei][j + 1].speed) {
                    // eslint-disable-next-line no-continue
                    continue
                  }
                  // eslint-disable-next-line radix
                  sum += parseInt(resp.result[imei][j].speed)

                  // استخراج امن مختصات از پاسخ API
                  let lat, lng
                  const posData = resp.result[imei][j]
                  if (posData.latitude && typeof posData.latitude === 'object' && posData.latitude.$numberDecimal) {
                    lat = parseFloat(posData.latitude.$numberDecimal)
                    lng = parseFloat(posData.longitude.$numberDecimal)
                  } else {
                    lat = parseFloat(posData.latitude || posData.lat)
                    lng = parseFloat(posData.longitude || posData.lon)
                  }
                  if (Number.isNaN(lat) || Number.isNaN(lng)) {
                    // eslint-disable-next-line no-continue
                    continue
                  }
                  const position = [lat, lng]
                  arr.push(position)

                  // افزودن ابتدا و انتها
                  if (j === 0) {
                    this.dateHistory = resp.result[imei][j].devicetime
                    const temp = {}
                    temp.state = 'start'
                    temp.latlng = position
                    temp.rotationAngle = 0
                    this.mapMarkers[Math.floor(Math.random() * 999999)] = temp
                  } else if (j === resp.result[imei].length - 1) {
                    const temp = {}
                    temp.state = 'end'
                    temp.latlng = position
                    temp.rotationAngle = 0
                    this.mapMarkers[Math.floor(Math.random() * 999999)] = temp
                  } else if (resp.result[imei][j].servertime - resp.result[imei][j - 1].servertime > 600) {
                    const temp = {}
                    temp.state = 'stop'
                    temp.latlng = position
                    temp.rotationAngle = 0
                    this.mapMarkers[Math.floor(Math.random() * 999999)] = temp
                  }
                  this.polyline.latlngs.push(position)
                  const time = resp.result[imei][j].devicetime
                  this.polyline.devicetime.push(time)
                  const { speed } = resp.result[imei][j]
                  this.polyline.devicespeed.push(speed)
                }
                this.averageSpeed = parseInt(sum / resp.result[imei].length)
                if (resp.result[imei].length > 0 && this.$refs.map && this.$refs.map.mapObject && this.polyline.latlngs.length > 0) {
                  this.$refs.map.mapObject.fitBounds(this.polyline.latlngs)
                }
              }
            }
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('Error'),
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
              dir: Vue.prototype.$functions.currentLangDirection(),
            },
          })
        },
      )
    },
    mapWayPointsAction() {
      if (this.mapHistoryDateFromFormatted === '') {
        alert('Date error.')
        return
      }

      const payload = {
        imeis: [this.selectedImei],
        fromDate: jalalimoment(`${this.mapHistoryDateFromFormatted} ${this.mapHistoryTimeStart}`, 'jYYYY/jMM/jDD HH:mm').unix(),
        toDate: jalalimoment(`${this.mapHistoryDateFromFormatted} ${this.mapHistoryTimeEnd}`, 'jYYYY/jMM/jDD HH:mm').unix(),
        limit: 0,
        sortItems: [{ name: 'servertime', asc: true }],
      }

      this.playBackVisible = true
      this.routing(payload)
    },
    getUnixTimeStartEndFormat(arr) {
      arr.start = jalalimoment(arr.start * 1000).locale('fa').format('YYYY/M/D')
      this.mapHistoryDateFromFormatted = arr.start
    },
    NextDay() {
      const ddd = jalalimoment(this.mapHistoryDateFromFormatted, 'jYYYY/jMM/jDD').unix() + 24 * 60 * 60
      const newd = jalalimoment(ddd * 1000).locale('fa').format('YYYY/M/D')
      this.mapHistoryDateFromFormatted = newd
    },
    PreviousDay() {
      const ddd = jalalimoment(this.mapHistoryDateFromFormatted, 'jYYYY/jMM/jDD').unix() - 24 * 60 * 60
      const newd = jalalimoment(ddd * 1000).locale('fa').format('YYYY/M/D')
      this.mapHistoryDateFromFormatted = newd
    },
    todayWayPoints() {
      this.getUnixTimeStartEndFormat(this.$functions.lastDaysTimes(0))
    },
    last7DaysWayPoints() {
      this.getUnixTimeStartEndFormat(this.$functions.lastDaysTimes(7))
    },
    last30DaysWayPoints() {
      this.getUnixTimeStartEndFormat(this.$functions.lastDaysTimes(30))
    },
    last60DaysWayPoints() {
      this.getUnixTimeStartEndFormat(this.$functions.lastDaysTimes(60))
    },
    getMarkerImei(index) {
      if (this.isMobile && this.selectedImei) {
        return this.selectedImei
      }
      return index
    },
    async getAddress() {
      const deviceInfo = Vue.prototype.$functions.getDeviceInfo(this.selectedDevice)
      if (!deviceInfo || !deviceInfo.serverInfo) return
      const coords = Vue.prototype.$functions.getLatLngFromServerInfo(deviceInfo.serverInfo)
      if (!coords) return
      this.address = await Vue.prototype.$functions.getFullAddress({
        latitude: coords.lat,
        longitude: coords.lng,
      }, this.selectedDevice)
    },
    onMobileMapShowHistoryBar() {
      this.mapHistoryDateFromFormatted = ''
      // eslint-disable-next-line prefer-destructuring

      this.historySideBarVisible = true

      const deviceInfo = Vue.prototype.$functions.getDeviceInfo(this.selectedDevice)
      if (!deviceInfo) return
      if (deviceInfo.serverInfo) {
        const coords = Vue.prototype.$functions.getLatLngFromServerInfo(deviceInfo.serverInfo)
        if (coords) {
          this.setMapCenterAndZoom([coords.lat, coords.lng], 16)
        }
      }

      // مخفی کردن سایر خودروها از روی نقشه به‌صورت موقت
      const selectedImei = deviceInfo.imei

      Object.keys(this.mapMarkers).forEach(imei => {
        if (selectedImei !== imei) {
          this.mapMarkers[imei].visible = false
        } else {
          this.mapMarkers[imei].visible = true
        }
      })

      this.todayWayPoints()
    },
    getPopupInfo(index) {
      if (typeof index === 'undefined') {
        return false
      }
      return Vue.prototype.$functions.fixDeviceInfo(Vue.prototype.$functions.getDeviceInfo(this.getMarkerImei(index)))
    },
    setMapCenterAndZoom(center, zoom) {
      if (this.$refs.map) {
        if (zoom) {
          this.$refs.map.setZoom(zoom)
        }
        this.$refs.map.setCenter(center)
      }
      // this.$refs.map.mapObject.setView(center, zoom)
    },
    isVisibleMarker(imei, lat, lon) {
      if (this.selectedDeviceTracking === imei) {
        return true
      }
      if (this.selectedDeviceTracking !== null) {
        return false
      }
      if (lat < 0 || lon < 0) {
        return false
      }
      if (this.selectedDevice === imei) {
        return true
      }
      let find = false
      const i = 0
      Object.keys(this.listLimitDevice)
        .forEach(keyIsImei => {
          if (this.listLimitDevice[keyIsImei] === imei) {
            find = true
          }
        })
      if (find) return true
      return false
    },
    async addUpdateMarker(marker) {
      const data = marker

      if (typeof data.imei === 'undefined') {
        return
      }
      if (typeof data.imei === 'undefined' || typeof data.latitude === 'undefined' || typeof data.longitude === 'undefined') {
        data.latitude = 0
        data.longitude = 0
        return
      }
      if (data.imei in this.mapMarkers && this.mapMarkers[data.imei]) {
        this.lastAngle = this.calcAngle(this.mapMarkers[data.imei].latlng[0], this.mapMarkers[data.imei].latlng[1], data.latitude, data.longitude) + 90
        if (this.lastAngle === 90) {
          this.lastAngle = this.mapMarkers[data.imei].rotationAngle
        }
      } else {
        this.lastAngle = Math.floor(Math.random() * (180 + 1))
      }

      if (this.isMobile && this.selectedDeviceTracking === data.imei) {
        //  this.address = await Vue.prototype.$functions.getFullAddress(data)
        // const deviceInfo = Vue.prototype.$functions.getDeviceInfo(this.selectedDeviceTracking)
        // this.setMapCenterAndZoom([deviceInfo.serverInfo.latitude.$numberDecimal,
        //  deviceInfo.serverInfo.longitude.$numberDecimal], 16)
        this.setMapCenterAndZoom([data.latitude, data.longitude], 16)
      }
      this.speed = data.speed
      if (data.speed === '' || data.speed == null) this.speed = 0

      this.mapMarkers[data.imei] = {
        // علاوه بر اینکه باید برای نمایش انتخاب شده باشد اگر
        // مقادیر مختصاتی نا معتبر داشته باشد هم نباید نمایش داده شود زیرا
        // نقطه نمایش پرت خواهد بود و نامرتبط
        visible: this.isVisibleMarker(data.imei, data.longitude, data.longitude),
        // visible: data.visible,
        latlng: [data.latitude, data.longitude],
        rotationAngle: this.lastAngle,
      }
      this.$forceUpdate()
    },
  },
}
</script>

<style>
[dir=rtl] * {
  font-family: Vazir;
}

[dir=rtl] .leaflet-zoom-animated {
  transform-origin:   0% 0% !important;
  -webkit-transform-origin:   0% 0% !important;
  -ms-transform-origin:   0% 0% !important;
}

[dir=rtl] .leaflet-marker-icon {
  transform-origin: center center 0px !important;
}

[dir=rtl] .leaflet-pane, [dir=rtl] .leaflet-tile, [dir=rtl] .leaflet-marker-icon,
[dir=rtl] .leaflet-marker-shadow, [dir=rtl] .leaflet-tile-container, [dir=rtl] .leaflet-pane > svg,
[dir=rtl] .leaflet-pane > canvas, [dir=rtl] .leaflet-zoom-box, [dir=rtl] .leaflet-image-layer, [dir=rtl]
.leaflet-layer {
  right: unset !important;
}

.nodiplay .content-header{
  display: none !important;
}
.nodiplay .content-body{
  margin: -47px -27px !important;
}

[dir=rtl] #playBackMap {
  width: calc( 100vw - 400px );
  height: calc( 100vh - 60px );
  direction: ltr !important;
  text-align: left !important;
  padding: 0 !important;
  margin: 0 !important;
  top: 49px !important;
  right: 400px !important;
  position: absolute;
}

#playBack .deviceRow {
  margin-bottom: 4px;
  width: 100%;
  padding: 5px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  transition: all 0.3s cubic-bezier(.25,.8,.25,1);
  border-radius: 5px;
  cursor: pointer;
  margin-bottom: 7px;
}

#playBack .deviceRow:hover {
  box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
}

.deviceInfo .card-body {
  padding-top: 8px !important;
}
#playBack .card-body {
  padding-top: 0;
  /*
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
  */

}

.vpd-input-group input {
  border-radius: 0;
  text-align: center;
}

.vpd-input-group label {
  margin-bottom: 0 !important;
}
@media (min-width: 768px) {
  [dir=rtl] .historySideBar {
    bottom: 0px;
    right: 50vw;
    padding-top: 20px;
  }
}
[dir=rtl] .devicesSideBar{
  top: 50px;
}
[dir=rtl] .devicesSideBar .card-body{
  padding-left: 0.4rem;
  padding-right: 0.4rem;
}
[dir=rtl] .devicesSideBar {
  height: 100vh;
}
[dir=rtl] .historySideBar, [dir=rtl] .devicesSideBar{
  z-index: 998;
  width: 400px;
  overflow-y: hidden;
  position: absolute;
  border-radius: 0;
  background: #f7f7f7;
  box-shadow: 0 0 15px rgba(0,0,0,0.55);
  clip-path: inset(0px -15px 0px 0px);
}

.devicesSideBar .card, .devicesSideBar .card-body, .historySideBar .card, .historySideBar .card-body {
  background: #f7f7f7;
}

.deviceRow {
  background: #fff;
}

[dir=rtl] .devicesSideBar {
  right: 0;
}
@media (min-width: 568px) {
  [dir=rtl] .playBackMob {
    bottom: 0px;

  width: calc( 100vw - 430px);
  left: 15px;
  top: unset;
  position: fixed;
  height: 150px;
  padding-top: 0px;
  margin-bottom: 0;
  z-index: 999;
  display:table;

  }
}
[dir=rtl] .playBackMob .card-body{
  padding: 0px !important;
}
.collapse .card-body{
  padding-left: 0.3rem !important;
  padding-right: 0.3rem !important;
}
@media (max-width: 767px) {
  [dir=rtl] #playBackMap {
    width: 100vw;
    height: calc( 100% - 115px );
    direction: ltr !important;
    text-align: left !important;
    padding: 0 !important;
    margin: 0 !important;
    top: 60px !important;
    position: absolute;

    right: inherit  !important;
    left: 0 !important;
  }
  [dir="rtl"] .historySideBar, [dir="rtl"] .devicesSideBar {
    width: 100%;
  }
  [dir="rtl"] .devicesSideBar {
    height: calc(100% - 50px);
    top: 0px;
    z-index: 999;
  }
  .leaflet-bottom{
    bottom: unset !important;
    top: 40px;
  }
  .leaflet-control-zoom{
    top: 70px;
  }
  .leaflet-control-zoom a{
    color: gray;
  }
  [dir="rtl"] #playBack .v-data-table > .v-data-table__wrapper > table > tbody > tr > td{
    height: 70px !important;;
  }
}
.historySideBar-btn{
  display: flex;
  padding: 5px 10px;
  border-radius: 5px;
  cursor: pointer;
}
@media (max-width: 567px) {
  [dir] .historySideBar .vpd-input-group input {
    background: #ececec;
    border: 0px;
    color: #393939;
    text-align: center;
  }
  [dir] .historySideBar .vpd-main{
    border: 1px solid #fff;
    border-radius: 5px;
  }

  .historySideBar-btn{
    display: flex;
    padding: 5px 10px;
    border: 1px solid #fff;
    border-radius: 5px;
  }
  [dir=rtl] .playBackMob {
    /*background: #54acca;*/
    width: 100%;
    right: 0;
    top: unset;
    position: fixed;
    bottom: 0px;
    padding-top: 0px;
    margin-bottom: 0;
    z-index: 999;
    overflow-x: hidden;
  }

  [dir=rtl] .playBackMob .card-body{
    padding: 0px !important;
  }

  [dir=rtl] .historySideBar .card-body{
    padding: 0 !important;
    background: unset !important;
  }
  .historySideBarBody label{
    color:#555 !important;
  }
  .historySideBar-btn i{
    color:#555 !important;
  }
  [dir=rtl] .historySideBar .historySideBarBody{
    background: #fff !important;
    border-top: 1px solid #fffbfb;
    margin-top: 0px;
    padding: 21px 15px !important;
    bottom: 0;
    position: fixed;
  }
  [dir=rtl] .historySideBar {
    background: #034f1a00;
    width: 100%;
    left: 0;
    top: unset;
    position: fixed;
    bottom: 0px;
    height: 130px;
    padding-top: 0px;
    margin-bottom: 0;
    z-index: 999;
    overflow-x: hidden;
  }
  [dir=rtl] .historySideBar h4 {
    display: none;
  }
}

.onlineSymbol, .offlineSymbol {
  height: 6px;
  width: 6px;
  border-radius: 50%;
  display: inline-block;
}

.onlineSymbol {
  background-color: #39e340;
}

.offlineSymbol {
  background-color: #b5b5b5;
}

.mobileOnMapHint {
  position: absolute;
  z-index: 999;
  background: rgba(100, 121, 128, 0.67);
  opacity: 0.9;
  border-radius: 5px;
  padding: 3px 6px 3px 6px;
  color: white;
  font-size: 1rem;
}

.mobileOnMapHintBtns {
  background: none;
}

.mobileOnMapHint button {
  height: 32px;
  width: 32px;
  padding: 0;
  font-size: 1.1rem;
  background: rgb(72, 128, 147) !important;
}

.mobileOnMapHistoryBtn {
  border-radius: 3px;
  padding: 0;
  opacity: 0.8;
  background: unset;
  right: 10px;
  bottom: 50px
}

.mobileOnMapHistoryBtn button {
  text-align: center;
  color: #eee;
  background: #5113db;
}

[dir=rtl] .mobileOnMapHintHistoryTime {
  bottom: 100px;
  left: 10px;
}
[dir=rtl] .mobileOnMapHintHistorySpeed {
  bottom: 100px;
  right: 10px;
}

[dir=rtl] .mobileOnMapHintCrosshairBtn {
  top: 32px;
  left: 5px;
  background: #fff;
  padding: 0px;
  border: 2px solid #d0cfcf;
}

[dir=rtl] #playBack .addDeviceBtn {
  height: 37px;
  width: 38px;
  z-index: 999;
  padding: 0
}
[dir] .btn-secondary:active{
  background-color: unset !important;
}
[dir=rtl] .playBtn {
  cursor: pointer;
  background: #ea121200 !important;
  border: 0px !important;
  top: 10px;
  width: fit-content;
  position: absolute;
  z-index: 999;
  padding: 0
}
.leaflet-control-attribution {
  display: none;
}

.vpd-wrapper {
  z-index: 999 !important;
}
.rounded-circle{
  color: #fff !important;
}
#playBack .vpd-icon-btn{
  display: none !important;
}
.v-menu{
  display: block !important;
}

.v-menu__content {
  font-size: 12px !important;
  opacity: 1 !important;
  background: #fff !important;
  box-shadow: 0 3px 14px rgba(0,0,0,0.4);
}
.Vue-Toastification__container{
  z-index: 9999999999999;
}
</style>
